import React, { Component } from "react"
import TableTermoCircunstanciado from "./TableTermoCircunstanciado"
import Layout from "../../Layout"
import { Loading, HttpError } from "../../../components"
import * as ApiHelper from "../../../ApiHelper"
import Moment from "moment"
export default class TermoCircunstanciado extends Component {
  constructor() {
    super()
    this.getTermos = this.getTermos.bind(this)
    this.didDelete = this.didDelete.bind(this)
    this.filter = this.filter.bind(this)
    this.state = { termos: [], initialTermos: [], showTable: false }
  }
  componentWillMount() {
    this.getTermos()
  }
  getTermos() {
    ApiHelper.getTermos((termos, error) => {
      if (termos) {
        this.setState({
          termos: termos,
          initialTermos: termos,
          showTable: true
        })
      } else {
        this.setState({
          httpError: error
        })
      }
    })
  }
  filter(event) {
    var searchText = event.target.value.toLowerCase()
    var filtered = this.state.initialTermos.filter(termo => {
      return (
        Moment(termo.created_at)
          .format("D/MM/Y")
          .toLowerCase()
          .search(searchText) !== -1 ||
        termo.parecer.toLowerCase().search(searchText) !== -1 ||
        termo.ressalvaz.num_contrato.toLowerCase().search(searchText) !== -1
      )
    })
    this.setState({
      termos: filtered
    })
  }
  didDelete() {
    this.getTermos()
  }
  render() {
    if (this.state.httpError) {
      return (
        <Layout tabActive="Fiscalização">
          <HttpError
            message={this.state.httpError.message}
            status={this.state.httpError.status}
          />
        </Layout>
      )
    }
    return (
      <Layout tabActive="Fiscalização">
        {this.state.showTable ? (
          <TableTermoCircunstanciado
            filter={this.filter}
            onDelete={this.didDelete}
            sizeClass=""
            title={"Termo circunstanciado"}
            subtitle={"Listagem dos termos circunstanciados criados"}
            backgroundColor="as-blue"
            rows={this.state.termos}
          />
        ) : (
          <Loading />
        )}
      </Layout>
    )
  }
}



// WEBPACK FOOTER //
// ./src/views/fiscalizacao/termo-circunstanciado/TermoCircunstanciado.js